import React from "react";
import { CheckCircle, AlertTriangle, Info } from "lucide-react";

export default function InsightAlert({ alerts }) {
  const getSeverityColor = (severity) => {
    switch (severity) {
      case "DANGER":
        return {
          bg: "#FEF2F2",
          icon: <AlertTriangle size={18} color="#DC2626" />,
          titleColor: "#DC2626",
        };
      case "WARNING":
        return {
          bg: "#FEFCE8",
          icon: <AlertTriangle size={18} color="#D97706" />,
          titleColor: "#D97706",
        };
      case "INFO":
      default:
        return {
          bg: "#EFF6FF",
          icon: <Info size={18} color="#193CB8" />,
          titleColor: "#193CB8",
        };
    }
  };

  return (
    <div
      style={{
        border: "1px solid #e5e7eb",
        borderRadius: "12px",
        padding: "20px",
        background: "#ffffff",
              marginTop: "40px",

        boxShadow: "0px 1px 2px rgba(0,0,0,0.10), 0px 1px 3px rgba(0,0,0,0.10)",
      }}
    >
      <h4
        style={{
          fontSize: "20px",
          fontWeight: "600",
          color: "#374151",
          marginBottom: "14px",
        }}
      >
        Alerts & Insights
      </h4>
      {(alerts || []).map((alert, index) => {
        const severityConfig = getSeverityColor(alert.severity);
        return (
          <div
            key={index}
            style={{
              background: severityConfig.bg,
              borderRadius: "10px",
              padding: "14px 14px",
              marginBottom: index < (alerts?.length || 0) - 1 ? "10px" : "0",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                width: "100%",
              }}
            >
              <span style={{ display: "flex" }}>
                {severityConfig.icon}
              </span>
              <div
                style={{
                  color: severityConfig.titleColor,
                  fontWeight: "500",
                  fontSize: "17px",
                  marginBottom: "2px",
                }}
              >
                {alert.title}
              </div>
            </div>
            <p
              style={{
                color: "#4A5565",
                fontSize: "14px",
                fontWeight: "400",
                marginLeft: "28px",
              }}
            >
              {alert.message}
            </p>
          </div>
        );
      })}
    </div>
  );
}
